import { motion } from 'framer-motion'

import { ButtonRoundedSm } from '@apps-common/components/elements/button'
import { VertSpacerSm } from '@apps-common/components/layout'
import { ModalContainer } from '@apps-common/components/modals/modal'
import { commonIcons } from '@apps-common/config/icons'
import { ModalDismiss } from '@apps-common/config/modal'
import { IUnitTaskGroupModel } from '@apps-common/types/portal/unit-tasks'

export enum ProgramTaskModalAction {
  retry = 'retry',
  edit = 'edit',
  archive = 'archive',
  delete = 'delete',
  cancel = 'cancel',
  view = 'view'
}

export interface ITaskGroupOptionsModal {
  task: IUnitTaskGroupModel
}

export const ProgramTaskOptionsModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: ITaskGroupOptionsModal
}) => {
  const { task } = componentProps
  const { id, status, archived } = task
  const isAwaiting = false

  // const buildOptions = () => (
  //   <>
  //     <div className='flex flex-col'>
  //       {showRetry && (
  //         <>
  //           <ButtonRoundedSm
  //             type='button'
  //             loading={false}
  //             icon={<commonIcons.activateNow />}
  //             className='border-none !bg-success !text-success-content my-[10px]'
  //             callback={() => onDismiss(ServiceRequestUnitActivationAction.activateNow, ModalDismiss.Confirm)}
  //             text='Retry now'
  //           />
  //           <ButtonRoundedSm
  //             type='button'
  //             loading={false}
  //             icon={<commonIcons.activateOnPowerUp />}
  //             className='border-none !bg-warning !text-warning-content my-[5px]'
  //             callback={() => onDismiss(ServiceRequestUnitActivationAction.powerUp, ModalDismiss.Confirm)}
  //             text='Retry on power up'
  //           />
  //           <div className='border-t-[1px] border-secondary-content/70 w-full mx-auto my-[10px]' />
  //         </>
  //       )}
  //       {showActivate && (
  //         <>
  //           <ButtonRoundedSm
  //             type='button'
  //             loading={false}
  //             icon={<commonIcons.activateNow />}
  //             className='border-none !bg-success !text-success-content my-[10px]'
  //             callback={() => onDismiss(ServiceRequestUnitActivationAction.activateNow, ModalDismiss.Confirm)}
  //             text='Activate now'
  //           />
  //           <ButtonRoundedSm
  //             type='button'
  //             loading={false}
  //             icon={<commonIcons.activateOnPowerUp />}
  //             className='border-none !bg-warning !text-warning-content my-[5px]'
  //             callback={() => onDismiss(ServiceRequestUnitActivationAction.powerUp, ModalDismiss.Confirm)}
  //             text='Activate on power up'
  //           />
  //           <div className='border-t-[1px] border-secondary-content/70 w-full mx-auto my-[10px]' />
  //         </>
  //       )}
  //     </div>

  //     {showEdit && (
  //       <ButtonRoundedSm
  //         type='button'
  //         loading={isAwaiting}
  //         icon={<commonIcons.activationReview />}
  //         className='border-none !bg-warning !text-warning-content my-[10px]'
  //         callback={() => onDismiss(ServiceRequestUnitActivationAction.edit, ModalDismiss.Confirm)}
  //         text='Edit'
  //       />
  //     )}

  //     {showDelete && (
  //       <ButtonRoundedSm
  //         type='button'
  //         loading={isAwaiting}
  //         icon={<commonIcons.delete />}
  //         className='border-none !bg-error !text-error-content my-[10px]'
  //         callback={() => onDismiss(ServiceRequestUnitActivationAction.delete, ModalDismiss.Confirm)}
  //         text='Delete'
  //       />
  //     )}
  //     {showArchive && (
  //       <ButtonRoundedSm
  //         type='button'
  //         loading={isAwaiting}
  //         icon={<commonIcons.archive className='text-[0.8rem]' />}
  //         className='border-none !bg-pending !text-pending-content my-[10px]'
  //         callback={() => onDismiss(ServiceRequestUnitActivationAction.archive, ModalDismiss.Confirm)}
  //         text='Archive'
  //       />
  //     )}
  //     {canCancel && (
  //       <ButtonRoundedSm
  //         type='button'
  //         loading={false}
  //         icon={<commonIcons.cancel />}
  //         className='border-none !bg-error !text-error-content my-[10px]'
  //         callback={() => onDismiss(ServiceRequestUnitActivationAction.cancel, ModalDismiss.Confirm)}
  //         text='Cancel activation'
  //       />
  //     )}

  //     <div className='border-t-[1px] border-secondary-content/70 w-full mx-auto my-[10px]' />
  //     <ButtonRoundedSm
  //       type='button'
  //       loading={false}
  //       icon={<commonIcons.close className='text-[1.25em]' />}
  //       className='border-secondary-content/30 !bg-secondary-content/10 !text-secondary-content my-[10px]'
  //       callback={() => onDismiss(null, ModalDismiss.Cancel)}
  //       text='Close'
  //     />
  //   </>
  // )

  return (
    <ModalContainer innerClasses='!min-w-[calc(90%-2rem)] sm:!min-w-0 !w-auto !h-auto' containerClasses=''>
      <motion.div layout className='bg-secondary px-[2rem] py-[1.25rem] rounded-3xl w-full'>
        <div className='max-w-[220px] sm:w-[180px] flex flex-col mx-auto'>
          <div className='relative flex flex-col items-center'>
            {/* <div className='absolute'>
              <div
                className={classNames(
                  isAwaiting && 'control-spinner',
                  isControlOn(currentState) && 'control-spinner-reverse border-error-content/10 border-t-error border-b-error',
                  isControlOff(currentState) && 'border-success-content/10 border-t-success border-b-success'
                )}
              />
            </div> */}
            <div className='w-[50px] h-[50px] rounded-[25px] bg-secondary-content/[0.05] flex items-center justify-center'>
              <commonIcons.sbServiceRequests className='relative text-[1.25rem] text-secondary-content' />
            </div>
            <VertSpacerSm />
            <p className='uppercase text-secondary-content'>
              <div>Device Task</div>
            </p>
            <p className='text-secondary-content text-[0.75em]'>Some actions currently disabled</p>
          </div>
          <div className='border-t-[1px] border-secondary-content/70 w-full mx-auto my-[10px]' />
          <ButtonRoundedSm
            type='button'
            loading={false}
            icon={<commonIcons.reload className='text-[1.25em]' />}
            className='bg-info text-on-info my-[10px]'
            callback={() => onDismiss(ProgramTaskModalAction.retry, ModalDismiss.Confirm)}
            text='Retry'
          />
          <div className='border-t-[1px] border-secondary-content/70 w-full mx-auto my-[10px]' />
          <ButtonRoundedSm
            type='button'
            loading={false}
            icon={<commonIcons.close className='text-[1.25em]' />}
            className='bg-border text-text-muted my-[10px]'
            callback={() => onDismiss(null, ModalDismiss.Cancel)}
            text='Close'
          />
        </div>
      </motion.div>
    </ModalContainer>
  )
}
